import '@/assets/styles/global.scss';

/**
 * Component registry.
 * Each entry maps a CSS selector to a function that dynamically loads
 * the component class. The import only fires if the selector matches
 * something on the current page.
 */
const registry = [
  {
    selector: '.js-header',
    load: () => import('@/templates/base/header/header.js').then((m) => m.HeaderComponent),
  },
  {
    selector: '.js-accordion',
    load: () => import('@/templates/base/accordion/accordion.js').then((m) => m.AccordionComponent),
  },
  {
    selector: '.js-back-to-top',
    load: () =>
      import('@/templates/base/back-to-top/back-to-top.js').then((m) => m.BackToTopComponent),
  },
  {
    selector: '.js-article-tabs',
    load: () =>
      import('@/templates/base/article-tabs/article-tabs.js').then((m) => m.ArticleTabsComponent),
  },
  {
    selector: '.js-copyright-modal',
    load: () =>
      import('@/templates/base/copyright-modal/copyright-modal.js').then(
        (m) => m.CopyrightModalComponent
      ),
  },
  {
    selector: '.js-teaser-slider',
    load: () =>
      import('@/templates/base/teaser-slider/teaser-slider.js').then(
        (m) => m.TeaserSliderComponent
      ),
  },
  {
    selector: '.js-teaserlist',
    load: () =>
      import('@/templates/base/teaserlist/teaserlist.js').then((m) => m.TeaserlistComponent),
  },
  {
    selector: '.js-teaserlist-selected',
    load: () =>
      import('@/templates/base/teaserlist-selected/teaserlist-selected.js').then(
        (m) => m.TeaserlistSelectedComponent
      ),
  },
  {
    selector: '.js-linktopthemen',
    load: () =>
      import('@/templates/base/linktopthemen/linktopthemen.js').then(
        (m) => m.LinktopthemenComponent
      ),
  },
  {
    selector: '.js-iconteaser',
    load: () =>
      import('@/templates/base/iconteaser/iconteaser.js').then((m) => m.IconteaserComponent),
  },
  {
    selector: '.js-downloadimage',
    load: () =>
      import('@/templates/base/downloadimage/downloadimage.js').then(
        (m) => m.DownloadimageComponent
      ),
  },
  {
    selector: '.js-schongewusst',
    load: () =>
      import('@/templates/base/schongewusst/schongewusst.js').then(
        (m) => m.SchongewusstComponent
      ),
  },
  {
    selector: '.js-video-embed',
    load: () =>
      import('@/templates/base/video-embed/video-embed.js').then(
        (m) => m.VideoEmbedComponent,
      ),
  },
  {
    selector: '.js-galerie',
    load: () =>
      import('@/templates/base/galerie/galerie.js').then((m) => m.GalerieComponent),
  },
  {
    selector: '.js-klickstrecke',
    load: () =>
      import('@/templates/base/klickstrecke/klickstrecke.js').then(
        (m) => m.KlickstreckeComponent
      ),
  },
  {
    selector: '.js-newsletter',
    load: () =>
      import('@/templates/base/newsletter/newsletter.js').then((m) => m.NewsletterComponent),
  },
  {
    selector: '.js-jumplinks',
    load: () => import('@/templates/base/jumplinks/jumplinks.js').then((m) => m.JumplinksComponent),
  },
  {
    selector: '.js-statistik',
    load: () => import('@/templates/base/statistik/statistik.js').then((m) => m.StatistikComponent),
  },
  {
    selector: '.js-slidertextkacheln',
    load: () =>
      import('@/templates/base/slidertextkacheln/slidertextkacheln.js').then(
        (m) => m.SlidertextkachelnComponent
      ),
  },
  {
    selector: '.js-select',
    load: () => import('@/templates/base/select/select.js').then((m) => m.SelectComponent),
  },
  {
    selector: '.js-downloadlist',
    load: () =>
      import('@/templates/base/materialien/list.js').then((m) => m.DownloadlistComponent),
  },
  {
    selector: '.js-embedmedienquiz',
    load: () =>
      import('@/templates/base/embedmedienquiz/embedmedienquiz.js').then(
        (m) => m.EmbedmedienquizComponent
      ),
  },
  {
    selector: '.js-mediencoaches',
    load: () =>
      import('@/templates/base/mediencoaches/mediencoaches.js').then(
        (m) => m.MediencoachesComponent
      ),
  },
];

document.addEventListener('DOMContentLoaded', () => {
  registry
    .filter(({ selector }) => document.querySelector(selector))
    .forEach(({ selector, load }) => {
      load().then((Component) => {
        document.querySelectorAll(selector).forEach((el) => new Component({}, el));
      });
    });

  trackVisit();
});

function trackVisit() {
  const pid = (document.body.id.match(/^page_(\d+)$/) || [])[1];
  if (!pid) {
    return;
  }
  const separator = window.location.search ? '&' : '?';
  const url = `${window.location.href}${separator}type=19272&tx_ishbase_visits[pid]=${pid}`;
  fetch(url, { method: 'POST', credentials: 'same-origin' }).catch(() => {});
}
